/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DeclarationInvitationRouteImport } from './routes/declaration-invitation'
import { Route as CompletedApplicationRouteImport } from './routes/completed-application'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as TenantSlugRouteImport } from './routes/$tenantSlug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TenantSlugIndexRouteImport } from './routes/$tenantSlug/index'
import { Route as ReceiptApplicationIdRouteImport } from './routes/receipt.$applicationId'
import { Route as ApplicationsApplicationIdRouteImport } from './routes/applications/$applicationId'
import { Route as ProtectedMyOrganisationRouteImport } from './routes/_protected/my-organisation'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected/dashboard'
import { Route as ProtectedAccountRouteImport } from './routes/_protected/account'
import { Route as TenantSlugSignupRouteImport } from './routes/$tenantSlug/signup'
import { Route as TenantSlugLogoutRouteImport } from './routes/$tenantSlug/logout'
import { Route as TenantSlugLoginRouteImport } from './routes/$tenantSlug/login'
import { Route as TenantSlugDeclarationInvitationRouteImport } from './routes/$tenantSlug/declaration-invitation'
import { Route as TenantSlugCompletedApplicationRouteImport } from './routes/$tenantSlug/completed-application'
import { Route as TenantSlugProtectedRouteImport } from './routes/$tenantSlug/_protected'
import { Route as ApplicationsApplicationIdIndexRouteImport } from './routes/applications/$applicationId/index'
import { Route as ProtectedApplyApplicationIdRouteImport } from './routes/_protected/apply/$applicationId'
import { Route as TenantSlugReceiptApplicationIdRouteImport } from './routes/$tenantSlug/receipt.$applicationId'
import { Route as TenantSlugApplicationsApplicationIdRouteImport } from './routes/$tenantSlug/applications/$applicationId'
import { Route as TenantSlugProtectedStatisticsRouteImport } from './routes/$tenantSlug/_protected/statistics'
import { Route as TenantSlugProtectedMyOrganisationRouteImport } from './routes/$tenantSlug/_protected/my-organisation'
import { Route as TenantSlugProtectedDashboardRouteImport } from './routes/$tenantSlug/_protected/dashboard'
import { Route as TenantSlugProtectedAccountRouteImport } from './routes/$tenantSlug/_protected/account'
import { Route as TenantSlugProtectedAccessManagementRouteImport } from './routes/$tenantSlug/_protected/access-management'
import { Route as ProtectedApplyHowToUseIndexRouteImport } from './routes/_protected/apply/how-to-use.index'
import { Route as TenantSlugApplicationsApplicationIdIndexRouteImport } from './routes/$tenantSlug/applications/$applicationId/index'
import { Route as ApplicationsApplicationIdCollaboratorsCollaboratorIdRouteImport } from './routes/applications/$applicationId/collaborators/$collaboratorId'
import { Route as ProtectedApplyHowToUseCertificationNumberRouteImport } from './routes/_protected/apply/how-to-use.$certificationNumber'
import { Route as TenantSlugProtectedApplyApplicationIdRouteImport } from './routes/$tenantSlug/_protected/apply/$applicationId'
import { Route as TenantSlugProtectedApplyHowToUseIndexRouteImport } from './routes/$tenantSlug/_protected/apply/how-to-use.index'
import { Route as TenantSlugApplicationsApplicationIdCollaboratorsCollaboratorIdRouteImport } from './routes/$tenantSlug/applications/$applicationId/collaborators/$collaboratorId'
import { Route as TenantSlugProtectedApplyHowToUseCertificationNumberRouteImport } from './routes/$tenantSlug/_protected/apply/how-to-use.$certificationNumber'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DeclarationInvitationRoute = DeclarationInvitationRouteImport.update({
  id: '/declaration-invitation',
  path: '/declaration-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const CompletedApplicationRoute = CompletedApplicationRouteImport.update({
  id: '/completed-application',
  path: '/completed-application',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantSlugRoute = TenantSlugRouteImport.update({
  id: '/$tenantSlug',
  path: '/$tenantSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantSlugIndexRoute = TenantSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TenantSlugRoute,
} as any)
const ReceiptApplicationIdRoute = ReceiptApplicationIdRouteImport.update({
  id: '/receipt/$applicationId',
  path: '/receipt/$applicationId',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationsApplicationIdRoute =
  ApplicationsApplicationIdRouteImport.update({
    id: '/applications/$applicationId',
    path: '/applications/$applicationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProtectedMyOrganisationRoute = ProtectedMyOrganisationRouteImport.update({
  id: '/my-organisation',
  path: '/my-organisation',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAccountRoute = ProtectedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => ProtectedRoute,
} as any)
const TenantSlugSignupRoute = TenantSlugSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugLogoutRoute = TenantSlugLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugLoginRoute = TenantSlugLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugDeclarationInvitationRoute =
  TenantSlugDeclarationInvitationRouteImport.update({
    id: '/declaration-invitation',
    path: '/declaration-invitation',
    getParentRoute: () => TenantSlugRoute,
  } as any)
const TenantSlugCompletedApplicationRoute =
  TenantSlugCompletedApplicationRouteImport.update({
    id: '/completed-application',
    path: '/completed-application',
    getParentRoute: () => TenantSlugRoute,
  } as any)
const TenantSlugProtectedRoute = TenantSlugProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => TenantSlugRoute,
} as any)
const ApplicationsApplicationIdIndexRoute =
  ApplicationsApplicationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ApplicationsApplicationIdRoute,
  } as any)
const ProtectedApplyApplicationIdRoute =
  ProtectedApplyApplicationIdRouteImport.update({
    id: '/apply/$applicationId',
    path: '/apply/$applicationId',
    getParentRoute: () => ProtectedRoute,
  } as any)
const TenantSlugReceiptApplicationIdRoute =
  TenantSlugReceiptApplicationIdRouteImport.update({
    id: '/receipt/$applicationId',
    path: '/receipt/$applicationId',
    getParentRoute: () => TenantSlugRoute,
  } as any)
const TenantSlugApplicationsApplicationIdRoute =
  TenantSlugApplicationsApplicationIdRouteImport.update({
    id: '/applications/$applicationId',
    path: '/applications/$applicationId',
    getParentRoute: () => TenantSlugRoute,
  } as any)
const TenantSlugProtectedStatisticsRoute =
  TenantSlugProtectedStatisticsRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => TenantSlugProtectedRoute,
  } as any)
const TenantSlugProtectedMyOrganisationRoute =
  TenantSlugProtectedMyOrganisationRouteImport.update({
    id: '/my-organisation',
    path: '/my-organisation',
    getParentRoute: () => TenantSlugProtectedRoute,
  } as any)
const TenantSlugProtectedDashboardRoute =
  TenantSlugProtectedDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => TenantSlugProtectedRoute,
  } as any)
const TenantSlugProtectedAccountRoute =
  TenantSlugProtectedAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => TenantSlugProtectedRoute,
  } as any)
const TenantSlugProtectedAccessManagementRoute =
  TenantSlugProtectedAccessManagementRouteImport.update({
    id: '/access-management',
    path: '/access-management',
    getParentRoute: () => TenantSlugProtectedRoute,
  } as any)
const ProtectedApplyHowToUseIndexRoute =
  ProtectedApplyHowToUseIndexRouteImport.update({
    id: '/apply/how-to-use/',
    path: '/apply/how-to-use/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const TenantSlugApplicationsApplicationIdIndexRoute =
  TenantSlugApplicationsApplicationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => TenantSlugApplicationsApplicationIdRoute,
  } as any)
const ApplicationsApplicationIdCollaboratorsCollaboratorIdRoute =
  ApplicationsApplicationIdCollaboratorsCollaboratorIdRouteImport.update({
    id: '/collaborators/$collaboratorId',
    path: '/collaborators/$collaboratorId',
    getParentRoute: () => ApplicationsApplicationIdRoute,
  } as any)
const ProtectedApplyHowToUseCertificationNumberRoute =
  ProtectedApplyHowToUseCertificationNumberRouteImport.update({
    id: '/apply/how-to-use/$certificationNumber',
    path: '/apply/how-to-use/$certificationNumber',
    getParentRoute: () => ProtectedRoute,
  } as any)
const TenantSlugProtectedApplyApplicationIdRoute =
  TenantSlugProtectedApplyApplicationIdRouteImport.update({
    id: '/apply/$applicationId',
    path: '/apply/$applicationId',
    getParentRoute: () => TenantSlugProtectedRoute,
  } as any)
const TenantSlugProtectedApplyHowToUseIndexRoute =
  TenantSlugProtectedApplyHowToUseIndexRouteImport.update({
    id: '/apply/how-to-use/',
    path: '/apply/how-to-use/',
    getParentRoute: () => TenantSlugProtectedRoute,
  } as any)
const TenantSlugApplicationsApplicationIdCollaboratorsCollaboratorIdRoute =
  TenantSlugApplicationsApplicationIdCollaboratorsCollaboratorIdRouteImport.update(
    {
      id: '/collaborators/$collaboratorId',
      path: '/collaborators/$collaboratorId',
      getParentRoute: () => TenantSlugApplicationsApplicationIdRoute,
    } as any,
  )
const TenantSlugProtectedApplyHowToUseCertificationNumberRoute =
  TenantSlugProtectedApplyHowToUseCertificationNumberRouteImport.update({
    id: '/apply/how-to-use/$certificationNumber',
    path: '/apply/how-to-use/$certificationNumber',
    getParentRoute: () => TenantSlugProtectedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$tenantSlug': typeof TenantSlugProtectedRouteWithChildren
  '/completed-application': typeof CompletedApplicationRoute
  '/declaration-invitation': typeof DeclarationInvitationRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/signup': typeof SignupRoute
  '/$tenantSlug/completed-application': typeof TenantSlugCompletedApplicationRoute
  '/$tenantSlug/declaration-invitation': typeof TenantSlugDeclarationInvitationRoute
  '/$tenantSlug/login': typeof TenantSlugLoginRoute
  '/$tenantSlug/logout': typeof TenantSlugLogoutRoute
  '/$tenantSlug/signup': typeof TenantSlugSignupRoute
  '/account': typeof ProtectedAccountRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/my-organisation': typeof ProtectedMyOrganisationRoute
  '/applications/$applicationId': typeof ApplicationsApplicationIdRouteWithChildren
  '/receipt/$applicationId': typeof ReceiptApplicationIdRoute
  '/$tenantSlug/': typeof TenantSlugIndexRoute
  '/$tenantSlug/access-management': typeof TenantSlugProtectedAccessManagementRoute
  '/$tenantSlug/account': typeof TenantSlugProtectedAccountRoute
  '/$tenantSlug/dashboard': typeof TenantSlugProtectedDashboardRoute
  '/$tenantSlug/my-organisation': typeof TenantSlugProtectedMyOrganisationRoute
  '/$tenantSlug/statistics': typeof TenantSlugProtectedStatisticsRoute
  '/$tenantSlug/applications/$applicationId': typeof TenantSlugApplicationsApplicationIdRouteWithChildren
  '/$tenantSlug/receipt/$applicationId': typeof TenantSlugReceiptApplicationIdRoute
  '/apply/$applicationId': typeof ProtectedApplyApplicationIdRoute
  '/applications/$applicationId/': typeof ApplicationsApplicationIdIndexRoute
  '/$tenantSlug/apply/$applicationId': typeof TenantSlugProtectedApplyApplicationIdRoute
  '/apply/how-to-use/$certificationNumber': typeof ProtectedApplyHowToUseCertificationNumberRoute
  '/applications/$applicationId/collaborators/$collaboratorId': typeof ApplicationsApplicationIdCollaboratorsCollaboratorIdRoute
  '/$tenantSlug/applications/$applicationId/': typeof TenantSlugApplicationsApplicationIdIndexRoute
  '/apply/how-to-use/': typeof ProtectedApplyHowToUseIndexRoute
  '/$tenantSlug/apply/how-to-use/$certificationNumber': typeof TenantSlugProtectedApplyHowToUseCertificationNumberRoute
  '/$tenantSlug/applications/$applicationId/collaborators/$collaboratorId': typeof TenantSlugApplicationsApplicationIdCollaboratorsCollaboratorIdRoute
  '/$tenantSlug/apply/how-to-use/': typeof TenantSlugProtectedApplyHowToUseIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/completed-application': typeof CompletedApplicationRoute
  '/declaration-invitation': typeof DeclarationInvitationRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/signup': typeof SignupRoute
  '/$tenantSlug': typeof TenantSlugIndexRoute
  '/$tenantSlug/completed-application': typeof TenantSlugCompletedApplicationRoute
  '/$tenantSlug/declaration-invitation': typeof TenantSlugDeclarationInvitationRoute
  '/$tenantSlug/login': typeof TenantSlugLoginRoute
  '/$tenantSlug/logout': typeof TenantSlugLogoutRoute
  '/$tenantSlug/signup': typeof TenantSlugSignupRoute
  '/account': typeof ProtectedAccountRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/my-organisation': typeof ProtectedMyOrganisationRoute
  '/receipt/$applicationId': typeof ReceiptApplicationIdRoute
  '/$tenantSlug/access-management': typeof TenantSlugProtectedAccessManagementRoute
  '/$tenantSlug/account': typeof TenantSlugProtectedAccountRoute
  '/$tenantSlug/dashboard': typeof TenantSlugProtectedDashboardRoute
  '/$tenantSlug/my-organisation': typeof TenantSlugProtectedMyOrganisationRoute
  '/$tenantSlug/statistics': typeof TenantSlugProtectedStatisticsRoute
  '/$tenantSlug/receipt/$applicationId': typeof TenantSlugReceiptApplicationIdRoute
  '/apply/$applicationId': typeof ProtectedApplyApplicationIdRoute
  '/applications/$applicationId': typeof ApplicationsApplicationIdIndexRoute
  '/$tenantSlug/apply/$applicationId': typeof TenantSlugProtectedApplyApplicationIdRoute
  '/apply/how-to-use/$certificationNumber': typeof ProtectedApplyHowToUseCertificationNumberRoute
  '/applications/$applicationId/collaborators/$collaboratorId': typeof ApplicationsApplicationIdCollaboratorsCollaboratorIdRoute
  '/$tenantSlug/applications/$applicationId': typeof TenantSlugApplicationsApplicationIdIndexRoute
  '/apply/how-to-use': typeof ProtectedApplyHowToUseIndexRoute
  '/$tenantSlug/apply/how-to-use/$certificationNumber': typeof TenantSlugProtectedApplyHowToUseCertificationNumberRoute
  '/$tenantSlug/applications/$applicationId/collaborators/$collaboratorId': typeof TenantSlugApplicationsApplicationIdCollaboratorsCollaboratorIdRoute
  '/$tenantSlug/apply/how-to-use': typeof TenantSlugProtectedApplyHowToUseIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$tenantSlug': typeof TenantSlugRouteWithChildren
  '/_protected': typeof ProtectedRouteWithChildren
  '/completed-application': typeof CompletedApplicationRoute
  '/declaration-invitation': typeof DeclarationInvitationRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/signup': typeof SignupRoute
  '/$tenantSlug/_protected': typeof TenantSlugProtectedRouteWithChildren
  '/$tenantSlug/completed-application': typeof TenantSlugCompletedApplicationRoute
  '/$tenantSlug/declaration-invitation': typeof TenantSlugDeclarationInvitationRoute
  '/$tenantSlug/login': typeof TenantSlugLoginRoute
  '/$tenantSlug/logout': typeof TenantSlugLogoutRoute
  '/$tenantSlug/signup': typeof TenantSlugSignupRoute
  '/_protected/account': typeof ProtectedAccountRoute
  '/_protected/dashboard': typeof ProtectedDashboardRoute
  '/_protected/my-organisation': typeof ProtectedMyOrganisationRoute
  '/applications/$applicationId': typeof ApplicationsApplicationIdRouteWithChildren
  '/receipt/$applicationId': typeof ReceiptApplicationIdRoute
  '/$tenantSlug/': typeof TenantSlugIndexRoute
  '/$tenantSlug/_protected/access-management': typeof TenantSlugProtectedAccessManagementRoute
  '/$tenantSlug/_protected/account': typeof TenantSlugProtectedAccountRoute
  '/$tenantSlug/_protected/dashboard': typeof TenantSlugProtectedDashboardRoute
  '/$tenantSlug/_protected/my-organisation': typeof TenantSlugProtectedMyOrganisationRoute
  '/$tenantSlug/_protected/statistics': typeof TenantSlugProtectedStatisticsRoute
  '/$tenantSlug/applications/$applicationId': typeof TenantSlugApplicationsApplicationIdRouteWithChildren
  '/$tenantSlug/receipt/$applicationId': typeof TenantSlugReceiptApplicationIdRoute
  '/_protected/apply/$applicationId': typeof ProtectedApplyApplicationIdRoute
  '/applications/$applicationId/': typeof ApplicationsApplicationIdIndexRoute
  '/$tenantSlug/_protected/apply/$applicationId': typeof TenantSlugProtectedApplyApplicationIdRoute
  '/_protected/apply/how-to-use/$certificationNumber': typeof ProtectedApplyHowToUseCertificationNumberRoute
  '/applications/$applicationId/collaborators/$collaboratorId': typeof ApplicationsApplicationIdCollaboratorsCollaboratorIdRoute
  '/$tenantSlug/applications/$applicationId/': typeof TenantSlugApplicationsApplicationIdIndexRoute
  '/_protected/apply/how-to-use/': typeof ProtectedApplyHowToUseIndexRoute
  '/$tenantSlug/_protected/apply/how-to-use/$certificationNumber': typeof TenantSlugProtectedApplyHowToUseCertificationNumberRoute
  '/$tenantSlug/applications/$applicationId/collaborators/$collaboratorId': typeof TenantSlugApplicationsApplicationIdCollaboratorsCollaboratorIdRoute
  '/$tenantSlug/_protected/apply/how-to-use/': typeof TenantSlugProtectedApplyHowToUseIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$tenantSlug'
    | '/completed-application'
    | '/declaration-invitation'
    | '/login'
    | '/logout'
    | '/signup'
    | '/$tenantSlug/completed-application'
    | '/$tenantSlug/declaration-invitation'
    | '/$tenantSlug/login'
    | '/$tenantSlug/logout'
    | '/$tenantSlug/signup'
    | '/account'
    | '/dashboard'
    | '/my-organisation'
    | '/applications/$applicationId'
    | '/receipt/$applicationId'
    | '/$tenantSlug/'
    | '/$tenantSlug/access-management'
    | '/$tenantSlug/account'
    | '/$tenantSlug/dashboard'
    | '/$tenantSlug/my-organisation'
    | '/$tenantSlug/statistics'
    | '/$tenantSlug/applications/$applicationId'
    | '/$tenantSlug/receipt/$applicationId'
    | '/apply/$applicationId'
    | '/applications/$applicationId/'
    | '/$tenantSlug/apply/$applicationId'
    | '/apply/how-to-use/$certificationNumber'
    | '/applications/$applicationId/collaborators/$collaboratorId'
    | '/$tenantSlug/applications/$applicationId/'
    | '/apply/how-to-use/'
    | '/$tenantSlug/apply/how-to-use/$certificationNumber'
    | '/$tenantSlug/applications/$applicationId/collaborators/$collaboratorId'
    | '/$tenantSlug/apply/how-to-use/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/completed-application'
    | '/declaration-invitation'
    | '/login'
    | '/logout'
    | '/signup'
    | '/$tenantSlug'
    | '/$tenantSlug/completed-application'
    | '/$tenantSlug/declaration-invitation'
    | '/$tenantSlug/login'
    | '/$tenantSlug/logout'
    | '/$tenantSlug/signup'
    | '/account'
    | '/dashboard'
    | '/my-organisation'
    | '/receipt/$applicationId'
    | '/$tenantSlug/access-management'
    | '/$tenantSlug/account'
    | '/$tenantSlug/dashboard'
    | '/$tenantSlug/my-organisation'
    | '/$tenantSlug/statistics'
    | '/$tenantSlug/receipt/$applicationId'
    | '/apply/$applicationId'
    | '/applications/$applicationId'
    | '/$tenantSlug/apply/$applicationId'
    | '/apply/how-to-use/$certificationNumber'
    | '/applications/$applicationId/collaborators/$collaboratorId'
    | '/$tenantSlug/applications/$applicationId'
    | '/apply/how-to-use'
    | '/$tenantSlug/apply/how-to-use/$certificationNumber'
    | '/$tenantSlug/applications/$applicationId/collaborators/$collaboratorId'
    | '/$tenantSlug/apply/how-to-use'
  id:
    | '__root__'
    | '/'
    | '/$tenantSlug'
    | '/_protected'
    | '/completed-application'
    | '/declaration-invitation'
    | '/login'
    | '/logout'
    | '/signup'
    | '/$tenantSlug/_protected'
    | '/$tenantSlug/completed-application'
    | '/$tenantSlug/declaration-invitation'
    | '/$tenantSlug/login'
    | '/$tenantSlug/logout'
    | '/$tenantSlug/signup'
    | '/_protected/account'
    | '/_protected/dashboard'
    | '/_protected/my-organisation'
    | '/applications/$applicationId'
    | '/receipt/$applicationId'
    | '/$tenantSlug/'
    | '/$tenantSlug/_protected/access-management'
    | '/$tenantSlug/_protected/account'
    | '/$tenantSlug/_protected/dashboard'
    | '/$tenantSlug/_protected/my-organisation'
    | '/$tenantSlug/_protected/statistics'
    | '/$tenantSlug/applications/$applicationId'
    | '/$tenantSlug/receipt/$applicationId'
    | '/_protected/apply/$applicationId'
    | '/applications/$applicationId/'
    | '/$tenantSlug/_protected/apply/$applicationId'
    | '/_protected/apply/how-to-use/$certificationNumber'
    | '/applications/$applicationId/collaborators/$collaboratorId'
    | '/$tenantSlug/applications/$applicationId/'
    | '/_protected/apply/how-to-use/'
    | '/$tenantSlug/_protected/apply/how-to-use/$certificationNumber'
    | '/$tenantSlug/applications/$applicationId/collaborators/$collaboratorId'
    | '/$tenantSlug/_protected/apply/how-to-use/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TenantSlugRoute: typeof TenantSlugRouteWithChildren
  ProtectedRoute: typeof ProtectedRouteWithChildren
  CompletedApplicationRoute: typeof CompletedApplicationRoute
  DeclarationInvitationRoute: typeof DeclarationInvitationRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  SignupRoute: typeof SignupRoute
  ApplicationsApplicationIdRoute: typeof ApplicationsApplicationIdRouteWithChildren
  ReceiptApplicationIdRoute: typeof ReceiptApplicationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/declaration-invitation': {
      id: '/declaration-invitation'
      path: '/declaration-invitation'
      fullPath: '/declaration-invitation'
      preLoaderRoute: typeof DeclarationInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/completed-application': {
      id: '/completed-application'
      path: '/completed-application'
      fullPath: '/completed-application'
      preLoaderRoute: typeof CompletedApplicationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantSlug': {
      id: '/$tenantSlug'
      path: '/$tenantSlug'
      fullPath: '/$tenantSlug'
      preLoaderRoute: typeof TenantSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantSlug/': {
      id: '/$tenantSlug/'
      path: '/'
      fullPath: '/$tenantSlug/'
      preLoaderRoute: typeof TenantSlugIndexRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/receipt/$applicationId': {
      id: '/receipt/$applicationId'
      path: '/receipt/$applicationId'
      fullPath: '/receipt/$applicationId'
      preLoaderRoute: typeof ReceiptApplicationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applications/$applicationId': {
      id: '/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/applications/$applicationId'
      preLoaderRoute: typeof ApplicationsApplicationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/my-organisation': {
      id: '/_protected/my-organisation'
      path: '/my-organisation'
      fullPath: '/my-organisation'
      preLoaderRoute: typeof ProtectedMyOrganisationRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/account': {
      id: '/_protected/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof ProtectedAccountRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/$tenantSlug/signup': {
      id: '/$tenantSlug/signup'
      path: '/signup'
      fullPath: '/$tenantSlug/signup'
      preLoaderRoute: typeof TenantSlugSignupRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/logout': {
      id: '/$tenantSlug/logout'
      path: '/logout'
      fullPath: '/$tenantSlug/logout'
      preLoaderRoute: typeof TenantSlugLogoutRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/login': {
      id: '/$tenantSlug/login'
      path: '/login'
      fullPath: '/$tenantSlug/login'
      preLoaderRoute: typeof TenantSlugLoginRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/declaration-invitation': {
      id: '/$tenantSlug/declaration-invitation'
      path: '/declaration-invitation'
      fullPath: '/$tenantSlug/declaration-invitation'
      preLoaderRoute: typeof TenantSlugDeclarationInvitationRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/completed-application': {
      id: '/$tenantSlug/completed-application'
      path: '/completed-application'
      fullPath: '/$tenantSlug/completed-application'
      preLoaderRoute: typeof TenantSlugCompletedApplicationRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/_protected': {
      id: '/$tenantSlug/_protected'
      path: ''
      fullPath: '/$tenantSlug'
      preLoaderRoute: typeof TenantSlugProtectedRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/applications/$applicationId/': {
      id: '/applications/$applicationId/'
      path: '/'
      fullPath: '/applications/$applicationId/'
      preLoaderRoute: typeof ApplicationsApplicationIdIndexRouteImport
      parentRoute: typeof ApplicationsApplicationIdRoute
    }
    '/_protected/apply/$applicationId': {
      id: '/_protected/apply/$applicationId'
      path: '/apply/$applicationId'
      fullPath: '/apply/$applicationId'
      preLoaderRoute: typeof ProtectedApplyApplicationIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/$tenantSlug/receipt/$applicationId': {
      id: '/$tenantSlug/receipt/$applicationId'
      path: '/receipt/$applicationId'
      fullPath: '/$tenantSlug/receipt/$applicationId'
      preLoaderRoute: typeof TenantSlugReceiptApplicationIdRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/applications/$applicationId': {
      id: '/$tenantSlug/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/$tenantSlug/applications/$applicationId'
      preLoaderRoute: typeof TenantSlugApplicationsApplicationIdRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/_protected/statistics': {
      id: '/$tenantSlug/_protected/statistics'
      path: '/statistics'
      fullPath: '/$tenantSlug/statistics'
      preLoaderRoute: typeof TenantSlugProtectedStatisticsRouteImport
      parentRoute: typeof TenantSlugProtectedRoute
    }
    '/$tenantSlug/_protected/my-organisation': {
      id: '/$tenantSlug/_protected/my-organisation'
      path: '/my-organisation'
      fullPath: '/$tenantSlug/my-organisation'
      preLoaderRoute: typeof TenantSlugProtectedMyOrganisationRouteImport
      parentRoute: typeof TenantSlugProtectedRoute
    }
    '/$tenantSlug/_protected/dashboard': {
      id: '/$tenantSlug/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/$tenantSlug/dashboard'
      preLoaderRoute: typeof TenantSlugProtectedDashboardRouteImport
      parentRoute: typeof TenantSlugProtectedRoute
    }
    '/$tenantSlug/_protected/account': {
      id: '/$tenantSlug/_protected/account'
      path: '/account'
      fullPath: '/$tenantSlug/account'
      preLoaderRoute: typeof TenantSlugProtectedAccountRouteImport
      parentRoute: typeof TenantSlugProtectedRoute
    }
    '/$tenantSlug/_protected/access-management': {
      id: '/$tenantSlug/_protected/access-management'
      path: '/access-management'
      fullPath: '/$tenantSlug/access-management'
      preLoaderRoute: typeof TenantSlugProtectedAccessManagementRouteImport
      parentRoute: typeof TenantSlugProtectedRoute
    }
    '/_protected/apply/how-to-use/': {
      id: '/_protected/apply/how-to-use/'
      path: '/apply/how-to-use'
      fullPath: '/apply/how-to-use/'
      preLoaderRoute: typeof ProtectedApplyHowToUseIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/$tenantSlug/applications/$applicationId/': {
      id: '/$tenantSlug/applications/$applicationId/'
      path: '/'
      fullPath: '/$tenantSlug/applications/$applicationId/'
      preLoaderRoute: typeof TenantSlugApplicationsApplicationIdIndexRouteImport
      parentRoute: typeof TenantSlugApplicationsApplicationIdRoute
    }
    '/applications/$applicationId/collaborators/$collaboratorId': {
      id: '/applications/$applicationId/collaborators/$collaboratorId'
      path: '/collaborators/$collaboratorId'
      fullPath: '/applications/$applicationId/collaborators/$collaboratorId'
      preLoaderRoute: typeof ApplicationsApplicationIdCollaboratorsCollaboratorIdRouteImport
      parentRoute: typeof ApplicationsApplicationIdRoute
    }
    '/_protected/apply/how-to-use/$certificationNumber': {
      id: '/_protected/apply/how-to-use/$certificationNumber'
      path: '/apply/how-to-use/$certificationNumber'
      fullPath: '/apply/how-to-use/$certificationNumber'
      preLoaderRoute: typeof ProtectedApplyHowToUseCertificationNumberRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/$tenantSlug/_protected/apply/$applicationId': {
      id: '/$tenantSlug/_protected/apply/$applicationId'
      path: '/apply/$applicationId'
      fullPath: '/$tenantSlug/apply/$applicationId'
      preLoaderRoute: typeof TenantSlugProtectedApplyApplicationIdRouteImport
      parentRoute: typeof TenantSlugProtectedRoute
    }
    '/$tenantSlug/_protected/apply/how-to-use/': {
      id: '/$tenantSlug/_protected/apply/how-to-use/'
      path: '/apply/how-to-use'
      fullPath: '/$tenantSlug/apply/how-to-use/'
      preLoaderRoute: typeof TenantSlugProtectedApplyHowToUseIndexRouteImport
      parentRoute: typeof TenantSlugProtectedRoute
    }
    '/$tenantSlug/applications/$applicationId/collaborators/$collaboratorId': {
      id: '/$tenantSlug/applications/$applicationId/collaborators/$collaboratorId'
      path: '/collaborators/$collaboratorId'
      fullPath: '/$tenantSlug/applications/$applicationId/collaborators/$collaboratorId'
      preLoaderRoute: typeof TenantSlugApplicationsApplicationIdCollaboratorsCollaboratorIdRouteImport
      parentRoute: typeof TenantSlugApplicationsApplicationIdRoute
    }
    '/$tenantSlug/_protected/apply/how-to-use/$certificationNumber': {
      id: '/$tenantSlug/_protected/apply/how-to-use/$certificationNumber'
      path: '/apply/how-to-use/$certificationNumber'
      fullPath: '/$tenantSlug/apply/how-to-use/$certificationNumber'
      preLoaderRoute: typeof TenantSlugProtectedApplyHowToUseCertificationNumberRouteImport
      parentRoute: typeof TenantSlugProtectedRoute
    }
  }
}

interface TenantSlugProtectedRouteChildren {
  TenantSlugProtectedAccessManagementRoute: typeof TenantSlugProtectedAccessManagementRoute
  TenantSlugProtectedAccountRoute: typeof TenantSlugProtectedAccountRoute
  TenantSlugProtectedDashboardRoute: typeof TenantSlugProtectedDashboardRoute
  TenantSlugProtectedMyOrganisationRoute: typeof TenantSlugProtectedMyOrganisationRoute
  TenantSlugProtectedStatisticsRoute: typeof TenantSlugProtectedStatisticsRoute
  TenantSlugProtectedApplyApplicationIdRoute: typeof TenantSlugProtectedApplyApplicationIdRoute
  TenantSlugProtectedApplyHowToUseCertificationNumberRoute: typeof TenantSlugProtectedApplyHowToUseCertificationNumberRoute
  TenantSlugProtectedApplyHowToUseIndexRoute: typeof TenantSlugProtectedApplyHowToUseIndexRoute
}

const TenantSlugProtectedRouteChildren: TenantSlugProtectedRouteChildren = {
  TenantSlugProtectedAccessManagementRoute:
    TenantSlugProtectedAccessManagementRoute,
  TenantSlugProtectedAccountRoute: TenantSlugProtectedAccountRoute,
  TenantSlugProtectedDashboardRoute: TenantSlugProtectedDashboardRoute,
  TenantSlugProtectedMyOrganisationRoute:
    TenantSlugProtectedMyOrganisationRoute,
  TenantSlugProtectedStatisticsRoute: TenantSlugProtectedStatisticsRoute,
  TenantSlugProtectedApplyApplicationIdRoute:
    TenantSlugProtectedApplyApplicationIdRoute,
  TenantSlugProtectedApplyHowToUseCertificationNumberRoute:
    TenantSlugProtectedApplyHowToUseCertificationNumberRoute,
  TenantSlugProtectedApplyHowToUseIndexRoute:
    TenantSlugProtectedApplyHowToUseIndexRoute,
}

const TenantSlugProtectedRouteWithChildren =
  TenantSlugProtectedRoute._addFileChildren(TenantSlugProtectedRouteChildren)

interface TenantSlugApplicationsApplicationIdRouteChildren {
  TenantSlugApplicationsApplicationIdIndexRoute: typeof TenantSlugApplicationsApplicationIdIndexRoute
  TenantSlugApplicationsApplicationIdCollaboratorsCollaboratorIdRoute: typeof TenantSlugApplicationsApplicationIdCollaboratorsCollaboratorIdRoute
}

const TenantSlugApplicationsApplicationIdRouteChildren: TenantSlugApplicationsApplicationIdRouteChildren =
  {
    TenantSlugApplicationsApplicationIdIndexRoute:
      TenantSlugApplicationsApplicationIdIndexRoute,
    TenantSlugApplicationsApplicationIdCollaboratorsCollaboratorIdRoute:
      TenantSlugApplicationsApplicationIdCollaboratorsCollaboratorIdRoute,
  }

const TenantSlugApplicationsApplicationIdRouteWithChildren =
  TenantSlugApplicationsApplicationIdRoute._addFileChildren(
    TenantSlugApplicationsApplicationIdRouteChildren,
  )

interface TenantSlugRouteChildren {
  TenantSlugProtectedRoute: typeof TenantSlugProtectedRouteWithChildren
  TenantSlugCompletedApplicationRoute: typeof TenantSlugCompletedApplicationRoute
  TenantSlugDeclarationInvitationRoute: typeof TenantSlugDeclarationInvitationRoute
  TenantSlugLoginRoute: typeof TenantSlugLoginRoute
  TenantSlugLogoutRoute: typeof TenantSlugLogoutRoute
  TenantSlugSignupRoute: typeof TenantSlugSignupRoute
  TenantSlugIndexRoute: typeof TenantSlugIndexRoute
  TenantSlugApplicationsApplicationIdRoute: typeof TenantSlugApplicationsApplicationIdRouteWithChildren
  TenantSlugReceiptApplicationIdRoute: typeof TenantSlugReceiptApplicationIdRoute
}

const TenantSlugRouteChildren: TenantSlugRouteChildren = {
  TenantSlugProtectedRoute: TenantSlugProtectedRouteWithChildren,
  TenantSlugCompletedApplicationRoute: TenantSlugCompletedApplicationRoute,
  TenantSlugDeclarationInvitationRoute: TenantSlugDeclarationInvitationRoute,
  TenantSlugLoginRoute: TenantSlugLoginRoute,
  TenantSlugLogoutRoute: TenantSlugLogoutRoute,
  TenantSlugSignupRoute: TenantSlugSignupRoute,
  TenantSlugIndexRoute: TenantSlugIndexRoute,
  TenantSlugApplicationsApplicationIdRoute:
    TenantSlugApplicationsApplicationIdRouteWithChildren,
  TenantSlugReceiptApplicationIdRoute: TenantSlugReceiptApplicationIdRoute,
}

const TenantSlugRouteWithChildren = TenantSlugRoute._addFileChildren(
  TenantSlugRouteChildren,
)

interface ProtectedRouteChildren {
  ProtectedAccountRoute: typeof ProtectedAccountRoute
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
  ProtectedMyOrganisationRoute: typeof ProtectedMyOrganisationRoute
  ProtectedApplyApplicationIdRoute: typeof ProtectedApplyApplicationIdRoute
  ProtectedApplyHowToUseCertificationNumberRoute: typeof ProtectedApplyHowToUseCertificationNumberRoute
  ProtectedApplyHowToUseIndexRoute: typeof ProtectedApplyHowToUseIndexRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedAccountRoute: ProtectedAccountRoute,
  ProtectedDashboardRoute: ProtectedDashboardRoute,
  ProtectedMyOrganisationRoute: ProtectedMyOrganisationRoute,
  ProtectedApplyApplicationIdRoute: ProtectedApplyApplicationIdRoute,
  ProtectedApplyHowToUseCertificationNumberRoute:
    ProtectedApplyHowToUseCertificationNumberRoute,
  ProtectedApplyHowToUseIndexRoute: ProtectedApplyHowToUseIndexRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

interface ApplicationsApplicationIdRouteChildren {
  ApplicationsApplicationIdIndexRoute: typeof ApplicationsApplicationIdIndexRoute
  ApplicationsApplicationIdCollaboratorsCollaboratorIdRoute: typeof ApplicationsApplicationIdCollaboratorsCollaboratorIdRoute
}

const ApplicationsApplicationIdRouteChildren: ApplicationsApplicationIdRouteChildren =
  {
    ApplicationsApplicationIdIndexRoute: ApplicationsApplicationIdIndexRoute,
    ApplicationsApplicationIdCollaboratorsCollaboratorIdRoute:
      ApplicationsApplicationIdCollaboratorsCollaboratorIdRoute,
  }

const ApplicationsApplicationIdRouteWithChildren =
  ApplicationsApplicationIdRoute._addFileChildren(
    ApplicationsApplicationIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TenantSlugRoute: TenantSlugRouteWithChildren,
  ProtectedRoute: ProtectedRouteWithChildren,
  CompletedApplicationRoute: CompletedApplicationRoute,
  DeclarationInvitationRoute: DeclarationInvitationRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  SignupRoute: SignupRoute,
  ApplicationsApplicationIdRoute: ApplicationsApplicationIdRouteWithChildren,
  ReceiptApplicationIdRoute: ReceiptApplicationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
